import React from 'react';
import classnames from 'classnames';
import { Domingo } from '@fiverr-private/domingo';
import { atoms } from '@fiverr-private/theme';
import { I18n } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { mixpanel } from '@fiverr-private/obs';
import Link from '../Link';
import Nav from '../../../lib/Nav';

const LetUsManageYourProjectLink: React.FC = () => {
    const { userId, url } = getContext();

    const path = Domingo(url)
        .pro()
        .path(
            'content_pages_page',
            {
                page_slug: 'project-management',
            },
            {
                query: {
                    source: 'avatar_menu',
                },
            }
        ).url;
    const handleClick = () => mixpanel.track('Project management avatar menu clicked', {});
    const bqData = {
        group: 'header_clicks',
        type: 'clicked_header.clicked_on_pjp_entry_point_avatar_menu_mp',
        user: {
            id: userId,
            navigation_mode: 'buying',
        },
    };

    return (
        <Nav.PopoverItem>
            <Link
                href={path}
                rel="nofollow"
                onClick={handleClick}
                bigQueryData={bqData}
                className={classnames(atoms({ cursor: 'pointer' }), 'nav-link')}
            >
                <I18n k="header.let_manage_project" />
            </Link>
        </Nav.PopoverItem>
    );
};

export default LetUsManageYourProjectLink;
